import React from 'react'
import ProfileToggle from './ProfileToggle'
import WaitlistToggle from './WaitlistToggle'
import { ProfileInfo } from '../index'

const ProfileWrapper = ({ children, user }) => (
  <div className="md:p-4">
    <div className="flex flex-row flex-wrap w-full justify-between rounded-t-lg md:bg-woodsmokeBlack md:flex-nowrap">
      <div className="relative w-full order-2 p-4 mb-14 md:p-10 md:flex-1 md:order-none">
        <WaitlistToggle user={user} />
        <ProfileToggle user={user} />
        {children}
      </div>
      <div className="hidden order-1 rounded-tr-lg md:block md:overflow-y-hidden md:order-none w-full md:w-80">
        <ProfileInfo user={user} classes={{ container: 'md:bg-codGray' }} />
      </div>
    </div>
  </div>
)

export default ProfileWrapper
